import api from '../utils/api';

const getInstance = async (id) => {
  try {
    const response = await api.get(`/instances/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching instance ${id}:`, error);
    throw error;
  }
};

const getUserInstances = async () => {
  try {
    const response = await api.get('/instances');
    return response.data;
  } catch (error) {
    console.error('Error fetching user instances:', error);
    throw error;
  }
};

const updateMessageLimit = async (instanceId, messageLimit) => {
  try {
    const response = await api.put(`/instances/${instanceId}/message-limit`, {
      messageLimit
    });
    return response.data;
  } catch (error) {
    console.error('Error updating message limit:', error);
    throw error;
  }
};

// Экспорт по умолчанию
const instanceService = {
  getInstance,
  getUserInstances,
  getInstances: getUserInstances, // Алиас для совместимости
  updateMessageLimit
};

export default instanceService;

// Именованные экспорты для обратной совместимости
export { getInstance, getUserInstances, updateMessageLimit };